import Vue from 'vue'
import Layout from '@/layout'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
/**
 *
 * meta配置
 * title 面包屑用的标题
 * showNotice true为显示notice,不写则默认不显示
 * showBread true为显示bread,不写则默认不显示
 * showTabbar true为显示Tabbar,不写则默认不显示
 *
 */

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
}

Vue.use(VueRouter)


const routes = [
  {
    path: '/',
    component: Layout,
    children: [
      {
        path: '',
        component: Home,
        name: 'Home',
        meta: {
          title: '首页',
          navName: 'Home',
          showBread: false,
          showFooter: true,
          keepAlive: true,
        },
      },
      {
        path: 'Showcases',
        component: () => import('@/views/Showcases/Showcases'),
        name: 'Showcases',
        meta: {
          title: '案例展示',
          showBread: false,
          navName: 'Showcases',
          showFooter: true,
          keepAlive: true,
        },
        children: [
          {
            path: '/ShowcasesDetail',
            name: 'ShowcasesDetail',
            component: () => import('@/views/Showcases/ShowcasesDetail'),
            meta: {
              title: '案例展示详情',
              navName: 'ShowcasesDetail',
              showBread: false,
              keepAlive: false,
            },
          },
        ],
      },

      {
        path: 'NewsInfo',
        component: () => import('@/views/NewsInfo/NewsInfo'),
        name: 'NewsInfo',
        meta: {
          title: '资讯信息',
          showBread: false,
          navName: 'NewsInfo',
          showFooter: true,
          keepAlive: true,
        },
        children: [
          {
            path: '/NewsInfoDetail',
            name: 'NewsInfoDetail',
            component: () => import('@/views/NewsInfo/NewsInfoDetail'),
            meta: {
              title: '资讯信息详情',
              showBread: false,
              keepAlive: false,
            },
          },
        ],
      },
      {
        path: 'Events',
        component: () => import('@/views/Events/Events'),
        name: 'Events',
        meta: {
          title: '活动信息',
          showBread: false,
          navName: 'Events',
          showFooter: true,
          keepAlive: true,
        },
        children: [
          {
            path: '/EventsDetail',
            name: 'EventsDetail',
            component: () => import('@/views/Events/EventsDetail'),
            meta: {
              title: '活动信息详情',
              showBread: false,
              keepAlive: false,
            },
          },
        ],
      },
      {
        path: 'Connections',
        component: () => import('@/views/Connections/Connections'),
        name: 'Connections',
        meta: {
          title: '合作伙伴',
          showBread: false,
          navName: 'Connections',
          showFooter: true,
          keepAlive: true,
        },
        children: [
          {
            path: '/ConnectionsDetail',
            name: 'ConnectionsDetail',
            component: () => import('@/views/Connections/ConnectionsDetail'),
            meta: {
              title: '合作伙伴详情',
              showBread: false,
              keepAlive: false,
            },
          },
        ],
      },
      {
        path: 'Accelerator',
        component: () => import('@/views/Accelerator/Accelerator'),
        name: 'Accelerator',
        meta: {
          title: '加速器',
          showBread: false,
          navName: 'Accelerator',
          showFooter: true,
          keepAlive: true,
        },
        children: [
          {
            path: '/AcceleratorDetail',
            name: 'AcceleratorDetail',
            component: () => import('@/views/Accelerator/AcceleratorDetail'),
            meta: {
              title: '加速器详情',
              showBread: false,
              keepAlive: false,
            },
          },
        ],
      },
      {
        path: 'AboutUs',
        component: () => import('@/views/AboutUs/index'),
        name: 'AboutUs',
        meta: {
          title: '关于我们',
          showBread: false,
          navName: 'AboutUs',
          showFooter: true,
          keepAlive: true,
        },
      },
    ],
  },
  {
    path: '*',
    redirect: '/',
  }
]
const router = new VueRouter({
  routes,
})

export default router
